<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="PraiseTitle1" id="_idParaDest-1">PRAISE FOR JOHN McFETRIDGE</p>
<p class="praiseTitle">BLACK ROCK</p>
<p class="praise">“Canadian author/screenwriter McFetridge has earned critical praise for <em class="itals">Everybody Knows This Is Nowhere</em> (2008) and other previous works, but is still looking for a ‘breakout book.’ With its well-etched family drama and dynamic historical background, <em class="itals">Black Rock </em>might finally be the one.”</p>
<p class="praise_attrib"><em class="itals">— </em><em class="itals">Kirkus Reviews</em></p>
<p class="praise">“[An] excellent historical procedure … Well done history and a really good plot line.”</p>
<p class="praise_attrib"><em class="itals">— </em><em class="itals">Globe and Mail</em></p>
<p class="praise">“[McFetridge]’s prose remains stripped back and forceful, the action propelled by laconic dialogue and the likeable Eddie Dougherty’s refusal to allow politics to interfere with his personal pursuit of justice … It’s a fascinating backdrop, too.”</p>
<p class="praise_attrib"><em class="itals">— </em><em class="itals">The Irish Times</em></p>
<p class="praiseTitle">DIRTY SWEET</p>
<p class="praise">“McFetridge is an author to watch. He has a great eye for detail, and Toronto has never looked seedier.”</p>
<p class="praise_attrib"><em class="itals">— Globe and Mail</em></p>
<p class="praise">“McFetridge combines a tough and gritty story populated by engagingly seedy characters … with an effective use of a setting, Toronto.”</p>
<p class="praise_attrib"><em class="itals">— Booklist</em></p>
<p class="praise">“The dubious fun is in the dialogue and details of a very entertaining and libidinous local debut.” </p>
<p class="praise_attrib"><em class="itals">— Toronto Star</em></p>
<p class="praise">“If more people wrote the kind of clean-as-a-whistle, no-fat prose McFetridge does, this reviewer would finish a lot more of their books.” </p>
<p class="praise_attrib"><em class="itals">— </em><em class="itals">National Post</em></p>
<p class="praiseTitle">EVERYBODY KNOWS THIS IS NOWHERE</p>
<p class="praise">“Amid the busy plot, McFetridge does a good job depicting a crime-ridden Toronto (a.k.a. the Big Smoke) that resembles the wide-open Chicago of Prohibition days with corrupt cops, gang warfare, and flourishing prostitution.”</p>
<p class="praise_attrib"><em class="itals">— Publishers Weekly</em></p>
<p class="praise">“This is McFetridge’s second novel, and once again, Toronto is a leading character in a fine crime-novel. The city’s sprawling growth, its ethnic diversity, and its ‘almost American’ focus on money are all ongoing motifs that enrich a novel already rich in on-the-make immigrants, edgy cops, and charming, devious women. Sex. Dope. Immigration. Gang war. Filmmaking. In McFetridge’s hands, Toronto might as well be the new L.A. of crime fiction.”</p>
<p class="praise_attrib"><em class="itals"> — Booklist</em></p>
<p class="praiseTitle">SWAP</p>
<p class="praise">“[<em class="itals">Swap</em>] grabs you by the throat and squeezes until you agree to read just one page, just one more page.”</p>
<p class="praise_attrib"><em class="itals"> — Quill &amp; Quire</em></p>
<p class="praise">“In just three novels … McFetridge has demonstrated gifts that put him in Elmore Leonard territory as a writer, and make Toronto as gritty and fascinating as Leonard’s Detroit…. [McFetridge] is a class act, and he’s creating fictional classics — maybe even that great urban literature of Toronto the critics now and then long for.”</p>
<p class="praise_attrib"><em class="itals"> — London Free Press</em></p>
<p class="praiseTitle">TUMBLIN’ DICE</p>
<p class="praise">“He’s the guy with just the right balance of grit, humour, and rock’n’roll knowledge to do the job.” </p>
<p class="praise_attrib"><em class="itals">— Toronto Star</em></p>
<p class="praise">“Dialogue that sizzles and sparks through the pages, providing its own music, naturally of the hard-rocking kind.” </p>
<p class="praise_attrib"><em class="itals">— Toronto Sun</em></p>
<p class="praise">“Each of John McFetridge’s … novels has a rhythm to them, mixing taut dialogue, spare description and a dark sensibility with the cool calm of a master bass player.” </p>
<p class="praise_attrib"><em class="itals">— National Post</em></p>
<p class="praise">“John McFetridge is — or should be — a star in the world of crime fiction.”</p>
<p class="praise_attrib"><em class="itals"> — London Free Press</em> </p>
<p class="praise">“Like [Elmore] Leonard, McFetridge is able to convincingly portray flawed figures on both sides of the law.” </p>
<p class="praise_attrib">— <em class="itals">Publishers Weekly</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ALittleMoreFree_Text_Final.vue?8fa6c982